import React from 'react';
import { Pane, PropertyGrid, Selector, TextInput } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { ns } from '@leverege/i18n';
import StripedGraphBackgroundModel from "../../models/background/StripedGraphBackgroundModel.js";
const {
  t
} = ns('ui-attributes-graphs.editors.StripedGraphBackgroundEditor');
const options = [{
  value: ['diagonal'],
  get name() {
    return t('diagonal');
  }
}, {
  value: ['diagonalRightToLeft'],
  get name() {
    return t('reverseDiagonal');
  }
}, {
  value: ['diagonal', 'diagonalRightToLeft'],
  get name() {
    return t('bothDiagonal');
  }
}, {
  value: ['horizontal'],
  get name() {
    return t('horizontal');
  }
}, {
  value: ['vertical'],
  get name() {
    return t('vertical');
  }
}, {
  value: ['vertical', 'horizontal'],
  get name() {
    return t('verticalAndHorizontal');
  }
}];
export default function StripedGraphBackgroundEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(StripedGraphBackgroundModel, props);
  return /*#__PURE__*/React.createElement(PropertyGrid, {
    variant: "glyphEditor|editor",
    inline: true
  }, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('baseColor')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: StripedGraphBackgroundModel.getBackgroundColor(value),
    eventData: "setBackgroundColor",
    onChange: onModelChange,
    hint: "Background"
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('stripeColor')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: StripedGraphBackgroundModel.getStripeColor(value),
    eventData: "setStripeColor",
    onChange: onModelChange,
    hint: "Stripe"
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('stripeOrientation')
  }, /*#__PURE__*/React.createElement(Selector, {
    values: options,
    value: StripedGraphBackgroundModel.getOrientation(value),
    onChange: onModelChange,
    eventData: "setOrientation"
  })));
}